import CommonHelmet from '@src/components/CommonHelmet';
import PrivacyPolicy from '@src/features/company/footer/PrivacyPolicy';

function FooterPrivacyPolicy() {
  return (
    <>
      <CommonHelmet />
      <PrivacyPolicy />
    </>
  );
}

export default FooterPrivacyPolicy;
